<template>
<div 
  v-if="data.is_in_stud" 
  class="mt-3 ui-card p-3 text-small"
  style="background: rgba(120,120,120,0.1);border: none;"
  >
    <div class="d-flex align-items-center">

      <div class="mr-4" style="line-height: 20px;">
        <span  class="">
          {{lg('',{
            en: 'Breeding Price',
            zh: '',
          })}}
        </span>
        <br>
        <h4 class="mt-2 mb-0">
          {{(data.auctionInfo || {}).price}} JGN
        </h4>
      </div>

      <div class="op4" style="line-height: 20px;">
        <span class="">
          {{lg('',{
            en: 'Time Left',
            zh: '',
          })}}
        </span>
        <br>
        <h4 class="mt-2 mb-0">
          {{(data.auctionInfo || {}).timeLeft}}
        </h4>
      </div>

      <div class="ml-auto">

        <router-link 
          :to="{name: 'breeding_item'}"
          @click.native="$store.commit('setDataBusKey',{
            data_on_select_mate: data,
          })"
          class="btn btn-primary ml-3"
          >
          {{lg('',{
            en: 'Breed Now',
            zh: '现在繁殖',
          })}}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'horseItemBlockSelectMate',
  components: {},
  props: [
    'data',
  ],
  data() {
    return {
      
    }
  },
  computed: {},
  watch: {},
  methods: {
    
  },
  created() {
    return
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  
</style>